import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function NotFoundPage() {
  const { isAuthenticated, user } = useAuth();

  function getHomePath() {
    if (!user) return '/login';
    switch (user.type) {
      case 'system_admin': return '/admin';
      case 'merchant': return '/merchant';
      case 'rider': return '/rider';
      default: return '/';
    }
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.icon}>404</div>
        <h1 style={styles.title} data-testid="not-found">الصفحة غير موجودة</h1>
        <p style={styles.subtitle}>عذراً، الصفحة التي تبحث عنها غير موجودة أو تم نقلها.</p>
        <Link to={getHomePath()} style={styles.link}>
          {isAuthenticated ? 'العودة إلى لوحة التحكم' : 'تسجيل الدخول'}
        </Link>
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex', justifyContent: 'center', alignItems: 'center',
    minHeight: '100vh', backgroundColor: '#f5f5f5',
  },
  card: {
    backgroundColor: 'white', borderRadius: '12px', padding: '48px',
    textAlign: 'center', boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
    maxWidth: '400px', width: '90%',
  },
  icon: { fontSize: '72px', fontWeight: '800', color: '#3E2C6E', lineHeight: 1, marginBottom: '16px' },
  title: { fontSize: '24px', color: '#333', margin: '0 0 8px 0' },
  subtitle: { fontSize: '14px', color: '#666', margin: '0 0 24px 0' },
  link: {
    display: 'inline-block', padding: '12px 24px', backgroundColor: '#3E2C6E',
    color: 'white', textDecoration: 'none', borderRadius: '6px',
    fontSize: '14px', fontWeight: '600',
  },
};
